/*
 * @Author: Lim 
 * @Date: 2020-09-14 15:32:51 
 * @Last Modified by: Lim
 * @Last Modified time: 2020-09-17 14:06:57
 */
import React, { useState, useEffect } from 'react';
import style from "./Radio.module.scss";
import cn from 'classnames'
import { initConfig } from '../common';

export default (props) => {
    /**
     * default
     */
    const defaultConfig = {
        defaultCheck:'1',
        data:[{ id: '1',value: '选项01'},{id:'2', value: '选项02', disable: true}],
        margin: '0 20px 0 0',
        color: '#3B99FC',
        check(){}
    }
    /**
     * initial
     * 数据对比
     */
    const { 
        defaultCheck,
        data,
        color,
        margin,
        check
    } = initConfig( defaultConfig, props.config );
    /**
     * state
     * 当前选中ID
     */
    const [ checkNow, setCheckNow] = useState( "1" );
    /**
     * didmount & update & unMount
     * update & unMount 
     */
    useEffect(() => {
        setCheckNow( defaultCheck )
    },[])
    /**
     * Func
     * 点击选择
     */
    const _check = (obj) => {
        if( obj.id == checkNow ) return false;
        if( obj.disable === true ) return false;
        setCheckNow( obj.id );
        check( obj );
    }
    /**
     * DOM
     */
    return (
        <div className={ style.main }>
            {data.map( ( obj, key)=>{
                return (
                    <span 
                        key= { key } 
                        className={ cn(style.radio_btn, obj.disable ? style.disable: "") }
                        style= {{ margin }}
                        onClick={()=>{ _check(obj) }}
                    >
                        <span 
                            className={ cn(
                                style.icon,
                                "font_family",
                                obj.id == checkNow ? "icon-radioSelected " : "icon-radioDefault" 
                            ) }
                            style = {{ color: obj.id == checkNow ? color : '' }}
                        ></span> 
                        <span>{ obj.value }</span>
                    </span>
                )
            })}
        </div>
    )
}
 